import { useEffect, useRef } from 'react'

const DRAG_THRESHOLD = 3

export function useDragToScroll(
  scrollContainerRef: React.RefObject<HTMLDivElement | null>
) {
  const isDraggingRef = useRef(false)

  useEffect(() => {
    const container = scrollContainerRef.current
    if (!container) return

    let startX = 0
    let startY = 0
    let startScrollLeft = 0
    let startScrollTop = 0
    let dragStarted = false

    const handleMouseDown = (e: MouseEvent) => {
      if (e.button !== 0) return
      const target = e.target
      if (
        target instanceof HTMLElement &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'BUTTON' ||
          target.tagName === 'TEXTAREA' ||
          target.closest('button'))
      ) {
        return
      }

      startX = e.clientX
      startY = e.clientY
      startScrollLeft = container.scrollLeft
      startScrollTop = container.scrollTop
      dragStarted = false
      isDraggingRef.current = false

      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }

    const handleMouseMove = (e: MouseEvent) => {
      const dx = e.clientX - startX
      const dy = e.clientY - startY

      if (
        !dragStarted &&
        Math.abs(dx) < DRAG_THRESHOLD &&
        Math.abs(dy) < DRAG_THRESHOLD
      ) {
        return
      }

      if (!dragStarted) {
        dragStarted = true
        isDraggingRef.current = true
        container.style.cursor = 'grabbing'
        container.style.userSelect = 'none'
      }

      container.scrollLeft = startScrollLeft - dx
      container.scrollTop = startScrollTop - dy
    }

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)

      if (dragStarted) {
        container.style.cursor = ''
        container.style.userSelect = ''
        isDraggingRef.current = false
      }
    }

    container.addEventListener('mousedown', handleMouseDown)
    return () => {
      container.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [scrollContainerRef])

  return isDraggingRef
}
